import { render, staticRenderFns } from "./ArchivesLogShow.vue?vue&type=template&id=57b84814&"
import script from "./ArchivesLogShow.vue?vue&type=script&lang=js&"
export * from "./ArchivesLogShow.vue?vue&type=script&lang=js&"
import style0 from "./ArchivesLogShow.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports